// import { v4 as uuidv4 } from "uuid";
const themeConfig = {
  app: {
    name: "Dashcode React",
  },
  // layout
  layout: {
    footerType: "static",
    isMonochrome: false,
    mobileMenu: false,
    customizer: false,
  },
};

export default themeConfig;
